import { useEffect, type ReactNode } from 'react';
import { useThemeStore } from '@shared/stores/theme.store';

type Props = {
  readonly children: ReactNode;
};

/**
 * Writes the active theme name to the `data-theme` attribute on
 * <html>, which is what the token sheets in `_styles/_theme-*.scss`
 * key off of. Subscribes to the Zustand theme store so changes
 * propagate without a page reload.
 */
export function ThemeProvider({ children }: Props): JSX.Element {
  const theme = useThemeStore((s) => s.theme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return <>{children}</>;
}
